import { tv } from 'tailwind-variants';

const timestampStyles = tv({
    slots: {
        base: "iris:text-(--comp-color-content-chat-message-timestamp)",
    },
    variants: {
        inverse: {
            true: {
                base: "iris:text-(--comp-color-content-chat-message-timestamp-inverse)",
            },
        },
    },
    defaultVariants: {
        inverse: false,
    },
});

export { timestampStyles };
